import './ThumbnailCardFilterOverview.scss';
import template from './ThumbnailCardFilterOverview.vhtml';

export default {
	name: 'ThumbnailCardFilterOverview',
	template: template,
	props: {
		endpoint: {
			type: String,
		},
		amount: {
			type: Number,
			default: -1,
		},
		search: {
			type: String,
			default: '',
		},
		category: {
			type: [Number, String],
			default: '',
		},
	},
};
